var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"height":"0px","position":"relative","float":"right"}},[_c('button',{staticClass:"common_add_btn",on:{"click":_vm.clickAction}},[_vm._v(_vm._s(_vm.isShowPlus ? '+ ' : '')+_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }